import withClasificacionTrabajador from "../../hoc/withTrabajadores/withClasificacionTrabajador";
import VistaClasificacionTrabajador from "../../view/components/RegistroUsuarios/Clasificacion/VistaClasificacion/VistaClasificacionTrabajador";

export default withClasificacionTrabajador(VistaClasificacionTrabajador)